import type { RouteObject } from 'react-router-dom';
import { ThemeColorMode } from 'src/common/enums';
import { routeProtector } from 'src/router/route-protector';
export const careersRoutes: RouteObject[] = [{
  path: '/careers',
  loader: routeProtector().requireCompletedOnboardingAndWelcome(),
  children: [{
    path: '',
    async lazy() {
      const {
        CareersHub
      } = await import('src/features/career-pages/careers-hub/careers-hub');
      return {
        Component: CareersHub
      };
    }
  }, {
    path: 'penetration-tester',
    async lazy() {
      const {
        PenetrationTester
      } = await import('src/features/career-pages/penetration-tester-v2');
      return {
        Component: PenetrationTester
      };
    }
  }, {
    path: 'security-engineer',
    async lazy() {
      const {
        SecurityEngineer
      } = await import('src/features/career-pages/security-engineer/security-engineer');
      return {
        Component: SecurityEngineer
      };
    }
  }, {
    path: 'red-teamer',
    async lazy() {
      const {
        RedTeamer
      } = await import('src/features/career-pages/red-teamer');
      return {
        Component: RedTeamer
      };
    }
  }, {
    path: 'incident-responder',
    async lazy() {
      const {
        IncidentResponder
      } = await import('src/features/career-pages/incident-responder');
      return {
        Component: IncidentResponder
      };
    }
  }, {
    path: 'cyber-security-analyst',
    async lazy() {
      const {
        CyberSecurityAnalyst
      } = await import('src/features/career-pages/cyber-security-analyst-v2');
      return {
        Component: CyberSecurityAnalyst
      };
    }
  }, {
    path: 'quiz/:result?',
    async lazy() {
      const {
        CareersQuiz
      } = await import('src/features/career-pages/careers-quiz/careers-quiz');
      return {
        Component: CareersQuiz
      };
    },
    handle: {
      forcedTheme: ThemeColorMode.DARK,
      hideFooter: true,
      hideHeader: true
    }
  }]
}];